<div class="p-wrapper-custom pagination-order py-3 single-right-pagination">
  <header
    class="samplepo-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>Invoices Posted this month</h1>
    <div class="samplepo-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportQuadReport3()">Export excel</a>
        <span class="cross-border" (click)="onClose()"
          ><i class="pi pi-times"></i
        ></span>
      </div>
    </div>
  </header>

  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="filteredQr3List"
    styleClass="p-datatable-customers"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="qr3List.length >= 20"
    [autoLayout]="true"
    [resizableColumns]="true"
    (onFilter)="onFilter($event)">
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center">Client</th>
        <th class="text-center">Job Name</th>
        <th class="text-center">Merch</th>
        <th class="text-center">Freight</th>
        <th class="text-center">Tax</th>
        <th class="text-center">Inv Total</th>
        <th class="text-center">Order</th>
        <th class="text-center">Invoice</th>
        <th class="text-center">Invoice Date</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="client"
              id="client"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'client', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="jobName"
              id="jobName"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'jobName', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="merch"
              id="merch"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'merch', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="freight"
              id="freight"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'freight', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="tax"
              id="tax"
              style="max-width: 200px"
              (input)="dt.filter($any($event.target).value, 'tax', 'contains')"
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="invTotal"
              id="invTotal"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'invTotal', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="order"
              id="order"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'order', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="invoice"
              id="invoice"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'invoice', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <jni-date-filter
            [dataList]="qr3List"
            [columnName]="invoiceDateColumn"
            (emitCancelFilter)="clearFilter($event)"
            (emitApplyFilter)="applyFilter($event)">
          </jni-date-filter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-qr3List let-rowIndex="rowIndex">
      <tr>
        <td>{{ qr3List.client }}</td>
        <td>{{ qr3List.jobName }}</td>
        <td class="align-right">{{ qr3List.merch | number: "1.2-2" }}</td>
        <td class="align-right">{{ qr3List.freight | number: "1.2-2" }}</td>
        <td class="align-right">{{ qr3List.tax | number: "1.2-2" }}</td>
        <td class="align-right">{{ qr3List.invTotal | number: "1.2-2" }}</td>
        <td>
          <a class="link" (click)="redirectToSummary(qr3List.order)">
            {{ qr3List.order }}</a
          >
        </td>
        <td>
          <a class="link" (click)="getProjectInvoiceReport(qr3List)">
            {{ qr3List.invoice }}
          </a>
        </td>
        <td>{{ qr3List.invoiceDate | date: "MM-dd-yyyy" }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="30">No Data Found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td colspan="2" class="text-right">Totals</td>
        <ng-container *ngIf="qr3Response">
          <!-- As per the ticket 12162 totals will show on filters -->
          <!-- <td class="text-end">
            {{ qr3Response.merchTotal | currency: 'USD' }}
          </td>
          <td class="text-end">
            {{ qr3Response.freightTotal | currency: 'USD' }}
          </td>
          <td class="text-end">{{ qr3Response.taxTotal | currency: 'USD' }}</td>
          <td class="text-end">
            {{ qr3Response.invTotalSum | currency: 'USD' }}
          </td> -->
          <td class="text-end">
            {{ totalMerch | currency: "USD" }}
          </td>
          <td class="text-end">
            {{ totalFreight | currency: "USD" }}
          </td>
          <td class="text-end">{{ totalTax | currency: "USD" }}</td>
          <td class="text-end">
            {{ totalInvTotal | currency: "USD" }}
          </td>
          <td colspan="3" class="text-end"></td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>
